import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PermissionCodes, RolePermissionResponse } from 'src/app/services/classes';
import { RefClient } from 'src/app/services/api-client';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-layout-sidebar',
  templateUrl: './layout-sidebar.component.html',
  styleUrls: ['./layout-sidebar.component.css']
})
export class LayoutSidebarComponent implements OnInit {

  isCommercialization?: boolean = false;
  showRequestList?: boolean = false;
  showPendingRequest?: boolean = false;
  showDashboard?: boolean = false;
  showSupport?: boolean = false;
  showAdministration?: boolean = false;
  showUser?: boolean = false;
  showRole?: boolean = false;
  showInspectionDate?: boolean = false;
  showDashboardImage?: boolean = false;
  showInspectionRequest?: boolean = false;
  showMetoceanPointsRequest?: boolean = false;
  showVectorizedDataRequest?: boolean = false;
  showPipeline?: boolean = false;
  showPipelineManagement?: boolean = false;
  showUWI?: boolean = false;
  showMetoceanPoints?: boolean = false;
  showVectorizedData?: boolean = false;
  showGIS?: boolean = false;
  showSpan?: boolean = false;
  showModel?: boolean = false;
  showMetocean?: boolean = false;
  showPrediction?: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private refclient: RefClient) { }

  ngOnInit(): void {
    let permissions: number[] = [];
    var id = localStorage.getItem("prspUserId")!;

    this.isCommercialization = environment.isCommercialization;

    // TODO: To get data from API for user module access.
    // Need to add flag (example: showAdministrator) and set to true if user have access.
    this.refclient.getPermissionsByUserId(id).pipe().subscribe((result) => {
      for (let entry of result) {
        let pm = {} as number;
        pm = entry.permissionCode;
        permissions.push(pm);
      }

      this.showDashboard = true;
      //this.showSupport = true;
      if (permissions.includes(PermissionCodes.ViewSupport)) this.showSupport = true;
      if (permissions.includes(PermissionCodes.ViewAdministration)) this.showAdministration = true;
      if (permissions.includes(PermissionCodes.ViewUser)) this.showUser = true;
      if (permissions.includes(PermissionCodes.ViewRole)) this.showRole = true;
      if (permissions.includes(PermissionCodes.ViewInspectionDate)) this.showInspectionDate = true;
      if (permissions.includes(PermissionCodes.ViewDashboardImage)) this.showDashboardImage = true;
      if (permissions.includes(PermissionCodes.ViewInspectionDataRequest)) this.showInspectionRequest = true;
      if (permissions.includes(PermissionCodes.ViewMPointsDataRequest)) this.showMetoceanPointsRequest = true;
      if (permissions.includes(PermissionCodes.ViewVDataDataRequest)) this.showVectorizedDataRequest = true;
      if (permissions.includes(PermissionCodes.ViewPipeline)) this.showPipelineManagement = true;
      if (permissions.includes(PermissionCodes.ViewUWI)) this.showUWI = true;
      if (permissions.includes(PermissionCodes.ViewMetocean)) this.showMetocean = true;
      if (permissions.includes(PermissionCodes.ViewMPoints)) this.showMetoceanPoints = true;
      if (permissions.includes(PermissionCodes.ViewVData)) this.showVectorizedData = true;
      if (permissions.includes(PermissionCodes.ViewGIS)) this.showGIS = true;
      if (permissions.includes(PermissionCodes.ViewSpan)) this.showSpan = true;
      if (permissions.includes(PermissionCodes.ViewSpan)) this.showModel = true;
      if (permissions.includes(PermissionCodes.ViewPrediction)) this.showPrediction = true;
      if (permissions.includes(PermissionCodes.ViewPendingRequest)) this.showPendingRequest = true;
      this.showRequestList = true;
      this.showPendingRequest = true;
    },
      error => {
        console.log(error.message);
      })


  }

  isAuthorized(code: number): boolean {
    var res = false;

    var id = localStorage.getItem("prspUserId")!;

    this.refclient.getPermissionsByUserId(id).pipe().subscribe((result) => {
      let permissions = [];
      for (let entry of result) {
        let pm = {} as number;
        pm = entry.permissionCode;
        permissions.push(pm);
      }

      if (permissions.includes(code)) res! = true;
      else res! = false;

      if (res) return true;
      else return false;
    },
      error => {
        console.log(error.message);
      })

    return res;
  }

  isActive(base: string): boolean {
    return this.activatedRoute.snapshot.url[0].path == base ? true : false;
  }

  isActiveSub(base: string): boolean {
    return this.activatedRoute.snapshot.children[0]?.url[0]?.path == base ? true : false;
  }
}
